import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { bool, oneOf, string } from "prop-types";

import { IconWrapper, Outline, Rect, Wrapper } from "./styled";

/**
 * Static ArrowIcon component
 */

const ArrowIcon = ({
  designFillColor,
  desktopPadding,
  direction,
  fillColor,
  isThinArrow,
  isWrapped,
  mobilePadding,
  width
}) => (
  <IconWrapper desktopPadding={desktopPadding} mobilePadding={mobilePadding}>
    {isThinArrow ? (
      <Wrapper direction={direction} viewBox="0 0 18 15" width={width}>
        <Outline>
          <Rect
            fillColor={fillColor}
            height="10.5268"
            transform="matrix(0.710669 0.703526 -0.710669 0.703526 7.50391 0)"
            width="1.00509"
          />
          <Rect
            fillColor={fillColor}
            height="10.558"
            transform="matrix(-0.710669 0.703526 0.710669 0.703526 0.714844 6.71436)"
            width="1.00509"
          />
          <Rect
            fillColor={fillColor}
            height="16.0006"
            transform="matrix(0 -1 -0.999949 0.010101 17.2188 7.9502)"
            width="1.00509"
          />
        </Outline>
      </Wrapper>
    ) : (
      <Wrapper direction={direction} viewBox="0 0 448 512" width={width}>
        <Outline
          designFillColor={designFillColor}
          fillColor={fillColor}
          fillRule="evenodd"
          isWrapped={isWrapped}
        >
          <path d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z" />
        </Outline>
      </Wrapper>
    )}
  </IconWrapper>
);

ArrowIcon.propTypes = {
  /** A string with information about desktop padding styles */
  desktopPadding: string,
  /** Indicates the arrow direction. By default the direction is down. */
  direction: oneOf(["up", "down", "right", "left"]),
  /** Make arrow icon thin */
  isThinArrow: bool,
  /** Indicates if the ArrowIcon should receive color behavior from a parent */
  isWrapped: bool,
  /** A string with information about padding on mobile devices. Default is null */
  mobilePadding: string,
  /** Give the icon a fill color (must be a color from the SE color library) */
  fillColor: oneOf(Object.keys(colors)),
  /** Give the icon an alternative fill color (from design-system/colors library) */
  designFillColor: string,
  /** Give the icon width/height (default is 21px) */
  width: string
};

ArrowIcon.defaultProps = {
  desktopPadding: "0 6px",
  designFillColor: "",
  direction: "down",
  isThinArrow: false,
  isWrapped: false,
  mobilePadding: "",
  fillColor: "koalaGrey",
  width: "21px"
};

export default ArrowIcon;
